import { Component, OnInit, SecurityContext, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FileItem, FileUploader } from "ng2-file-upload";
import { Modal } from "ngx-modal";
import { environment } from "../../../environments/environment";
import { ApiUrlConstants } from "../../common/constants/api.constants";

import { CustomerService } from "../../customerservice/services/customer.service";

@Component({
  selector: 'app-upload-media',
  templateUrl: "../templates/template1/views/upload-media.component.html",
  styleUrls: ["../templates/template1/themes/default/CSS/upload-media.component.less"]
})

export class UploadMediaComponent implements OnInit {

  @ViewChild('uploadFileModal') uploadFileModal: Modal;
  uploader: FileUploader;
  constructor(
    private _customerService: CustomerService,
    private _sanitizer: DomSanitizer
  ){}

  ngOnInit() {
    this.uploader = this.getFileUploader();
    this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem();
    // this.uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
    //   form = this._sanitizer.sanitize(SecurityContext.NONE, form);
  // }

  }

  openUploadFileModal(): void {
    this.uploadFileModal.open();

  }

  onSuccessItem(): any {

  }

  saveAttachments() {
    this.uploadFile();
}

uploadFile() {
  if (this.uploader && this.uploader.queue.length > 0) {
      // this.ngProgress.start();
      let filelength = 0;
      this.uploader.onBuildItemForm = (item: any, form: any) => {
          filelength++;
          item.withCredentials = false;
          item.uploader.authToken = this._customerService.getAuthorizationToken();
          const uploadedFileName =item.file.name.split(".");
          const generateFileName = uploadedFileName[0] + '_' + 'test' + '_' + filelength +'.' + uploadedFileName[uploadedFileName.length-1];
          form.append('fileName', decodeURIComponent(encodeURIComponent(generateFileName)));
          form.append('path', 'content/customer-service/' + 'test' + '/');
      };
      for (let i = 0; i < this.uploader.queue.length; i++) {
          this.uploader.queue[i].upload();
      }
  }
}

closeAttachmentPopUp(): void {
  this.uploader.queue = [];
  this.uploadFileModal.close();
}

getFileUploader(): FileUploader {
  let fileUploader: FileUploader;
  if (environment && environment.enableFileUploadToPrivate) {
    fileUploader = new FileUploader({
      url: ApiUrlConstants.cmsApiUrl + '/sanitized-upload-media' + '?isPrivate=true'
    });
  } else {
    fileUploader = new FileUploader({
      url: ApiUrlConstants.cmsApiUrl + '/sanitized-upload-media'
    });
  }
  return fileUploader;
}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-media.component.ts